
import { defineComponent } from "vue";
import { mapActions, mapState } from "vuex";

export default defineComponent({
  name: "TeacherBoard",
  computed: {
    ...mapState(["currentUser", "groups", "userGroups"]),
  },
  methods: {
    ...mapActions(["getGroupsFromApi", "getUserGroupsFromApi", "addGroupToUser", "deleteUserGroup"]),
    async handleAddToMyGroups(groupID: string) {
      await this.addGroupToUser(groupID);
    },
    async handleDeleteGroupe(groupID: string) {
      await this.deleteUserGroup(groupID);
    },
  },
  mounted() {
    this.getGroupsFromApi();
    this.getUserGroupsFromApi();
  },
  data() {
    return {
      isHiddenFormToCreate: true,
    };
  },
});
